module.exports = __webpack_public_path__ + "img/ajito.91f85ac0.png";